<template>
	<form @submit.prevent="onAction" novalidate class="form" :style="cssVars">
		<div class="form__content">
			<slot v-if="!state" />
			<slot v-if="state === 'success'" name="onSuccess" />
			<slot v-if="state === 'error'" name="onError" />
		</div>
	</form>
</template>

<script>
export default {
	props: {
		action: {
			type: Function,
		},
		maxWidth: {
			type: String,
			default: '100%',
		},
		isValid: {
			type: Boolean,
		},
		paddingLR: {
			type: String,
			default: '1.8rem',
		},
		paddingTB: {
			type: String,
			default: '1.8rem',
		},
	},
	data() {
		return {
			state: null,
		}
	},
	computed: {
		cssVars() {
			return {
				'--form-padding-l-r': this.paddingLR,
				'--form-padding-t-b': this.paddingTB,
				'--max-width': this.maxWidth,
			}
		},
	},
	methods: {
		onAction() {
			if (!this.isValid) return this.action()
			return this.action()
				.then(() => (this.state = 'success'))
				.catch(err => {
					console.log(err)

					this.state = 'error'
				})
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';

.form {
	&__content {
		padding: var(--form-padding-t-b) var(--form-padding-l-r);
		margin: auto;
		flex-grow: 1;
		background: $white;

		box-sizing: border-box;

		box-shadow: 0px 20px 40px -10px rgba(0, 0, 0, 5);
		border-radius: $border-radius;
		max-width: var(--max-width);
	}
}
</style>
